import { getCachedMediaUrl } from '../../../../../lib/utils/utils';

function ProductCard({ product }) {
    return (
        <div className="flex flex-col rounded-3xl overflow-hidden bg-[#232327]">
            <div className="w-full aspect-square rounded-3xl overflow-hidden">
                <img className='size-full object-cover' src={getCachedMediaUrl(product.VarientImgUrl[0])} alt={product.VarientName} />
            </div>

            <div className="p-2 pb-4 flex flex-col gap-[10px]">
                <div className='flex items-center gap-1'>
                    <p className='font-medium text-[16px] leading-7 text-[#FFFFFF]'>₹{product.VarientPrice}</p>

                    {
                        product.VarientMrp > product.VarientPrice && 
                        <>
                            <p className='font-normal text-[14px] leading-[26px] text-[#B0B0B0] line-through'>₹{product.VarientMrp}</p>

                            <p className='font-semibold text-[12px] leading-6 text-primaryColor'>{Math.round(((product.VarientMrp - product?.VarientPrice) / product.VarientMrp) * 100).toFixed(0)}% off</p>
                        </>
                    }
                </div>

                <p className='font-bold text-[14px] leading-[26px] text-[#FFFFFF] line-clamp-1'>{product.VarientName}</p>

                <p className='line-clamp-1 font-medium text-[12px] leading-6 text-[#B0B0B0]'>{product.prodDesc}</p>
            </div>
        </div>
    );
}

export default ProductCard;
